export default __webpack_public_path__ + "static/media/blog5.38efd737.jpg";